export type PvzInitialStateType = {
  description: string
  courierWay: string
  alarmSystem: string
  dressingRoomsCount: string
  racksCount: string
  cellsCount: string
  maxCellsCount: string
  videos: string[]
  documents: string[]
  photos: {
    url: string
    isPublic: boolean
  }[]
  features: boolean[]
}

/** Статус запроса на изменение площади */
export enum EditAreaStatus {
  none = 'REQUESTED_AREA_STATUS_NONE',
  inProgress = 'REQUESTED_AREA_STATUS_IN_PROCESS',
  accepted = 'REQUESTED_AREA_STATUS_ACCEPTED',
}

export enum TimetableStatus {
  none = '',
  approve = 'TIMETABLE_STATUS_APPROVE',
  waiting = 'TIMETABLE_STATUS_WAITING',
  reject = 'TIMETABLE_STATUS_NONE_APPROVE',
}

export type PvzFeature = {
  label: string
  checked: boolean
  value: string
}
